export const DashboardLoader = () => (
  <div class="Dashboard__Widget Dashboard__Widget__Loader">
    <div class="Spinner" />
  </div>
);
